import { Pipe, PipeTransform } from '@angular/core';
import { MarketingMenu } from '../../../models/menu/marketing-menu';
import type { Menu } from '../../../models/menu/menu';

@Pipe({
  name: 'isMarketingMenu',
  standalone: false
})
export class IsMarketingMenuPipe implements PipeTransform {
  transform(value: Menu): boolean {
    return value instanceof MarketingMenu;
  }
}
